<template>
  <div class="ucenter">
    <el-container>
      <el-aside width="260px">
        <div class="ucenter_top_logs" @click="tohome()">
          <div class="ep_log">奇迹ip网络</div>
        </div>
        <el-row class="tac">
          <el-col :span="24">
            <el-menu
                :default-active="activeMenu"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
                background-color="#1f2738"
                text-color="#fff"
                unique-opened="true"
                active-text-color="#ffd04b"
            >
              <el-submenu index="1">
                <template slot="title">
                  <div class="menu-title">
                    <img src="@/assets/icon_app.png" class="menu-icon"/>
                    <span>账户管理</span>
                  </div>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="jbxx" @click="clitoymtz('jbxx')">
                    <i class="el-icon-user"></i>
                    基本信息
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <!-- 订单管理 -->
              <el-submenu index="2">
                <template slot="title">
                  <div class="menu-title">
                    <img src="@/assets/icon_dp.png" class="menu-icon"/>
                    <span>我的订单</span>
                  </div>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="order_list" @click="clitoymtz('order_list')">
                    <i class="el-icon-document"></i>
                    订单管理
                  </el-menu-item>
                  <el-menu-item index="ip_resource_list" @click="clitoymtz('ip_resource_list')">
                    <i class="el-icon-goods"></i>
                    产品管理
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <!-- 账务管理 -->
              <el-submenu index="3">
                <template slot="title">
                  <div class="menu-title">
                    <img src="@/assets/icon_tj.png" class="menu-icon"/>
                    <span>账务管理</span>
                  </div>
                </template>
                <el-menu-item-group>
                  <!--                  <el-menu-item index="pay_list" @click="clitoymtz('pay_list')">-->
                  <!--                    余额充值-->
                  <!--                  </el-menu-item>-->
                  <el-menu-item index="pay_list" @click="clitoymtz('pay_list')">
                    余额账单
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>

            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-container>
        <el-header class="ucenter_header">
          <div class="head_ovft">
            <Head></Head>
          </div>
        </el-header>
        <el-main class="ucenter_main">
          <!--基本信息-->
          <div v-show="asidename == 'jbxx'">
            <Ucenter_jbxx ref="jbxx"></Ucenter_jbxx>
          </div>
          <div v-show="asidename == 'smrz'">
            <Ucenter_smrz ref="smrz"></Ucenter_smrz>
          </div>
          <div v-show="asidename == 'edxh'">
            <Ucenter_edxh ref="edxh"></Ucenter_edxh>
          </div>
          <!--我的订单-->
          <div v-show="asidename == 'pay_list'">
            <pay_list ref="pay_list"></pay_list>
          </div>
          <div v-show="asidename == 'order_list'">
            <order_list ref="order_list"></order_list>
          </div>
          <div v-show="asidename == 'ip_resource_list'">
            <ip_resource_list ref="ip_resource_list"></ip_resource_list>
          </div>

        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Head from "@/components/head_list/head.vue";
import Ucenter_jbxx from "@/components/ucenter_jbxx/ucenter_jbxx.vue";
import Ucenter_smrz from "@/components/ucenter_smrz/ucenter_smrz.vue";
import Ucenter_edxh from "@/components/ucenter_edxh/ucenter_edxh.vue";
import pay_list from "@/components/order/pay_list.vue";
import order_list from "@/components/order/order_list.vue";
import ip_resource_list from "@/components/order/ip_resource_list.vue";

export default {
  components: {
    Head,
    Ucenter_jbxx,
    Ucenter_smrz,
    Ucenter_edxh,
    pay_list,
    order_list,
    ip_resource_list,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "ucenter",
  data() {
    return {
      activeMenu: "jbxx",
      asidename: "jbxx",
    };
  },
  created() {
  },
  methods: {
    openWeChatChat() {
    },
    tohome() {
      this.$router.push({path: "/"});
    },
    clitoymtz(name) {
      this.asidename = name;
      if (this.$route.query.asidename !== name) {
        // 会刷新 url 里的 query 参数（推荐）
        this.$router.push({
          query: {
            ...this.$route.query, // 保留其他 query
            asidename: name
          }
        });
      }
      this.$refs[name] && this.$refs[name].refresh && this.$refs[name].refresh();
    },
    clc_to_api(name) {
      this.$router.push({
        path: "getapi", query: {name: name}
      });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  mounted() {
    let asidename = this.$route.query.asidename;
    if (asidename) {
      this.asidename = asidename;
      this.activeMenu = asidename;
    }
  },
};
</script>
<style>
.ucenter {
  height: 100vh;
  background-color: #f5f7fa;
}

.el-aside {
  background-color: #1f2738;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: width 0.3s;
}

.el-menu {
  border-right: none !important;
}

.el-menu-item {
  height: 50px !important;
  line-height: 50px !important;
  margin: 4px 0;
  border-radius: 4px;
  margin-right: 12px;
}

.el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.el-menu-item.is-active {
  background: linear-gradient(90deg, #4a90e2 0%, #357abd 100%) !important;
  box-shadow: 0 2px 6px rgba(74, 144, 226, 0.2);
}

.el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
  margin: 4px 0;
}

.el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
</style>
<style>
.ucenter_header {
  color: #333;
  background-color: #fff;
  padding: 16px 24px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  z-index: 10;
  transition: all 0.3s;
}

.ucenter_main {
  background-color: #f5f7fa;
  color: #333;
  padding: 24px;
  overflow-y: auto;
  height: calc(100vh - 60px);
}

.ep_log {
  font-weight: 700;
  font-size: 32px;
  padding: 16px 0;
  background: linear-gradient(45deg, #4a90e2, #357abd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  display: inline-block;
  transition: all 0.3s;
}

.ep_log:hover {
  transform: scale(1.02);
}

.ucenter_top_logs {
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  cursor: pointer;
}

.ucenter_top_logs > img {
  margin: 10px auto;
  width: 160px;
  padding: 8px 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.head_ovft {
  z-index: 51;
}

.menu-title {
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  opacity: 0.8;
  transition: all 0.3s;
}

.el-menu-item i {
  margin-right: 8px;
  font-size: 18px;
  color: #909399;
}

.el-menu-item.is-active i {
  color: #ffd04b;
}

/* 美化滚动条 */
.ucenter_main::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.ucenter_main::-webkit-scrollbar-thumb {
  background: #cfd7e6;
  border-radius: 3px;
}

.ucenter_main::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

</style>
